import classNames from "classnames";
import { NavigationModel } from "models/NavigationModel";
import { useNavigate } from "react-router";

export interface HeaderNavLinkProps extends NavigationModel {
  className?: string;
}

export const HeaderNavLink: React.FC<HeaderNavLinkProps> = ({
  className,
  onClick,
  href,
  target,

  iconStart,
  iconEnd,
  text,
}) => {
  const navigate = useNavigate();

  function handleClick() {
    if (href) {
      if (href.includes("://")) {
        if (target === "_blank") {
          window.open(href);
        } else {
          window.location.href = href;
        }
      } else {
        navigate(href);
      }
      return;
    }

    if (onClick) {
      onClick();
      return;
    }

    throw new Error("Empty href and onClick");
  }

  return (
    <a href="#" className={classNames("nav-link", className)} onClick={() => handleClick()}>
      {iconStart ? <div className="sbb-header-nav-item-icon me-2">{iconStart}</div> : null}
      {text}
      {iconEnd ? <div className="sbb-header-nav-item-icon ms-2">{iconEnd}</div> : null}
    </a>
  );
};
